module.exports = __webpack_public_path__ + "40be1a31ef7b848a1be7cfecc9a3c8d6.svg";